import { observer } from 'mobx-react-lite';
import React, { type PropsWithChildren } from 'react';

import { TableHead } from '@ifs-gcp/components';

import styles from './checklist-table.module.scss';

type ChecklistTableProps = {
  head: React.ReactElement;
  height?: number;
  wrapperRef: React.RefObject<HTMLDivElement | null>;
};

export const ChecklistTable = observer(
  ({ head, height, wrapperRef, children }: PropsWithChildren<ChecklistTableProps>) => {
    return (
      <div className={styles.wrapper} ref={wrapperRef}>
        <table className={styles.table}>
          <TableHead>{head}</TableHead>
          <tbody style={{ height }}>{children}</tbody>
        </table>
      </div>
    );
  },
);
